export type Brand = {
  id: string;
  name: string;
  mobilePortalId: number;
  desktopPortalId: number;
  order: number;
  createdAt: Date;
  updatedAt: Date;
  isBrandMaintenanceMode: boolean;
  brandMaintenanceModeDescription?: string;
};

export type BrandToUpdate = Partial<Omit<Brand, "id" | "updatedAt">>;

export enum BrandType {
  TELEGRAM = "telegram",
  INTERNATIONAL = "international",
  FREE = "free",
}
